import { useMutation } from "@/api/utils/useQuery"
import Cache from "@/api/utils/Cache"
import {
  BackofficeRestMutations,
  UpdatePaperBillPayload,
} from "@/api/backofficeRest/mutations"
import { MutationResult } from "@/api/utils/types"
import { IUpdatePaperBill } from "./PaperBillMutator.types"

export interface IPaperBillMutator {
  updatePaperBill(): MutationResult<IUpdatePaperBill, void>
}

class PaperBillMutatorClass implements IPaperBillMutator {
  updatePaperBill(): MutationResult<IUpdatePaperBill, void> {
    return useMutation({
      ...BackofficeRestMutations.paperBill.update(),
      serializerFn: (data: IUpdatePaperBill): UpdatePaperBillPayload => ({
        billingAccountId: data.billingAccountId,
        body: { enabled: data.enabled },
      }),
      onSuccessFn: () => {
        Cache.clear()
      },
    })
  }
}

export const PaperBillMutator = new PaperBillMutatorClass()
